
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/investments",
      function () {
        return require("private-next-pages/docs/investments/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/investments"])
      });
    }
  